import gql from 'graphql-tag';

export interface UploadDocumentResult {
  url?: string;
  citadelId?: number;
  documentType?: string;
}

export interface UploadDocumentMutationResult {
  uploadStudentDocument: UploadDocumentResult;
  uploadFinancialSponsorDocument: UploadDocumentResult;
}

const uploadDocument = (uploadType: string) => gql`
  mutation ${uploadType}(
    $fileName: String!,
    $documentType: DocumentType!,
    $documentDataUrl: String!,
  ) {
    ${uploadType}(
      fileName: $fileName,
      documentType: $documentType,
      documentDataUrl: $documentDataUrl,
    ) {
      url
      citadelId
      documentType
    }
  }
`;

export const uploadStudentDocument = uploadDocument('uploadStudentDocument');
export const uploadFinancialSponsorDocument = uploadDocument('uploadFinancialSponsorDocument');
